<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="M19 21a3 3 0 0 1-1.7-.6 3 3 0 0 1-1.1-1.4H11q-1.6 0-2.8-1.2A4 4 0 0 1 7 15q0-1.6 1.2-2.8T11 11h2q.8 0 1.4-.6T15 9t-.6-1.4A2 2 0 0 0 13 7H7.8a3 3 0 0 1-1 1.4Q5.8 9 5 9q-1.2 0-2.1-.9T2 6t.9-2.1T5 3q1 0 1.7.6.9.5 1.1 1.4H13q1.6 0 2.8 1.2T17 9t-1.2 2.8T13 13h-2a2 2 0 0 0-1.4.6A2 2 0 0 0 9 15q0 .8.6 1.4t1.4.6h5.2q.4-.9 1-1.4.9-.6 1.8-.6 1.2 0 2.1.9T22 18t-.9 2.1-2.1.9M5.7 6.7Q6 6.4 6 6l-.3-.7L5 5l-.7.3L4 6q0 .4.3.7T5 7t.7-.3"
    />
  </svg>
</template>
